<ion-content>
  <app-memory-viewer></app-memory-viewer>
  <app-audio-viewer></app-audio-viewer>
  <app-file-uploader></app-file-uploader>
  <app-user-auth></app-user-auth>
  <app-bio-modal></app-bio-modal>
  <app-trailmates-modal></app-trailmates-modal>
  <!-- <app-messages-modal></app-messages-modal> -->
  <app-credits></app-credits>
  <ion-header>
    <ion-toolbar>
      <ion-title>Menu</ion-title>
      <ion-buttons slot="end">
        <ion-button color="medium" (click)="closeMenu()">Close<ion-icon name="close"></ion-icon></ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <!-- Mini Map selection -->
  <ion-item button (click)="openMiniMapModal()">
    <ion-label>View Mini Map</ion-label>
    <ion-icon name="map-outline" slot="end"></ion-icon>
  </ion-item>
  <ion-accordion-group>
    <ion-accordion value="first">
      <ion-item slot="header" color="light">
        <ion-label>Game Settings</ion-label>
      </ion-item>
      <div class="ion-padding" slot="content">
        <ion-item>
          <ion-label>GPS Mode</ion-label>
          <ion-icon name="navigate-circle-outline"></ion-icon>
          <ion-toggle #toggle slot="end"
            (click)="gpsToggleClicked()"
            [(ngModel)]="gpsModeState"
            [disabled]="gpsMode.isConnecting"
            (touchmove)="$event.preventDefault(); $event.stopPropagation()"
            (pointermove)="$event.preventDefault(); $event.stopPropagation()"
          ></ion-toggle>
        </ion-item>
      </div>
      <div class="ion-padding" slot="content">
        <ion-item>
          <ion-label>Music</ion-label>
          <ion-icon name="musical-notes"></ion-icon>
          <ion-toggle #toggle slot="end"
            (ionChange)="toggleMusic($event)"
            [checked]="(this.globalService.getMusicPlaying() | async)"
            (touchmove)="$event.preventDefault(); $event.stopPropagation()"
            (pointermove)="$event.preventDefault(); $event.stopPropagation()"
          ></ion-toggle>
        </ion-item>
      </div>
      <!-- <div class="ion-padding" slot="content" [hidden]="!(globalService.$loggedIn | async)"> -->
      <div class="ion-padding" slot="content">
        <ion-item>
          <ion-label>Online Mode</ion-label>
          <ion-icon name="globe-outline"></ion-icon>
          <ion-toggle #toggle
            slot="end"
            (click)="onlineModeChanged()"
            [(ngModel)]="websocketService.isConnected"
            [disabled]="websocketService.isConnecting"
            (touchmove)="$event.preventDefault(); $event.stopPropagation()"
            (pointermove)="$event.preventDefault(); $event.stopPropagation()"
          >
          </ion-toggle>
        </ion-item>
      </div>
      <div class="ion-padding" slot="content">
        <ion-item id="credits-modal">
          <ion-label>Credits</ion-label>
        </ion-item>
      </div>
    </ion-accordion>
    <ion-accordion value="second">
      <ion-item slot="header" color="light">
        <ion-label>Teleport</ion-label>
      </ion-item>
      <div class="ion-padding" slot="content">
        <ion-list>
          <ion-item button *ngFor="let place of geoPlaces" (click)="placeSelected(place)">
            <td>{{place.name}}<ion-icon *ngIf="hasBeenGpsVisited(place.name)" name="diamond-outline"></ion-icon></td>
          </ion-item>
        </ion-list>
      </div>
    </ion-accordion>
      <ion-accordion value="third">
        <ion-item slot="header" color="light">
          <ion-label>Profile</ion-label>
        </ion-item>
        <div class="ion-padding" slot="content">
          <ion-list>
            <ion-item id="user-auth-modal">
              <ion-label expand="block">Account</ion-label>
              <ion-icon name="person-circle-outline" slot="end"></ion-icon>
            </ion-item>
            <ion-item id="file-uploader-modal" [hidden]="!(globalService.$loggedIn | async)">
              <ion-label expand="block">Photos</ion-label>
              <ion-icon name="image-outline" slot="end"></ion-icon>
            </ion-item>
            <ion-item id="profile-bio-modal" [hidden]="!(globalService.$loggedIn | async)">
              <ion-label>Bio</ion-label>
              <ion-icon name="document-text-outline" slot="end"></ion-icon>
            </ion-item>
            <ion-item id="trailmates-modal" [hidden]="!(globalService.$loggedIn | async)">
              <ion-label>Trailmates</ion-label>
              <ion-icon name="people-outline" slot="end"></ion-icon>
            </ion-item>
            <ion-item id="messages-modal" [hidden]="!(globalService.$loggedIn | async)" (click)="openMessagesModal()">
              <ion-label>Messages</ion-label>
              <ion-icon name="mail-outline" slot="end"></ion-icon>
            </ion-item>
            <ion-item id="audio-uploader-modal" [hidden]="!(globalService.$loggedIn | async)" (click)="openAudioUploaderModal()">
              <ion-label>Mix Tapes</ion-label>
              <ion-icon name="recording-outline" slot="end"></ion-icon>
            </ion-item>
          </ion-list>
        </div>
      </ion-accordion>
  </ion-accordion-group>
</ion-content>
